import { call, put } from "redux-saga/effects";
import { api, notify, queryBuilder } from "services";
import { IListRequest } from "interfaces/list-duck";
import { requestErrorHandler } from "utils";
import { PaginatePickingsActions } from "store/ducks/pickings";

export function* paginatePickingsRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IListRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(api.get, `/pickings-scheduling?${queryString}`);

    const { pickings, pagination } = data;
    yield put(PaginatePickingsActions.success(pickings, pagination));
    if (onSuccess) onSuccess({ pickings, pagination });
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(PaginatePickingsActions.failure(errorMessage));
  }
}
